var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('Toast',{attrs:{"position":"top-center"}}),_vm._v(" "),_c('ScrollTop',{attrs:{"threshold":200}}),_vm._v(" "),_c('transition',{attrs:{"name":"page","mode":"out-in","appear":""}},[_c('div',{key:_vm.$page.url,staticClass:"general-container my-2"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }